<template lang="pug" functional>
  .ration-skeleton
    .ration-skeleton__item(v-for="i in props.count")
      .ration-skeleton__loader
      .ration-skeleton__loader
</template>

<script>
export default {
  name: 'RationSkeleton',

  props: {
    count: {
      type: Number,
      default: 4
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_mixins.scss';

.ration-skeleton {
  padding: 1rem 2rem 0;

  &__item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  &__loader {
    height: 2rem;
    border-radius: .8rem;
    @include skeleton;

    &:first-child {
      width: 60%;
      margin-right: 4rem;
    }

    &:last-child {
      width: 40%;
    }
  }
}
</style>
